import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripAutoEndingDetails({
    label,
    options,
    isAutoEnding,
    onChange,
    isEditable,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={isAutoEnding}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
